import RefundTerms from '@v2/brands/magzoom/components/RefundTerms';
import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /refund.
 *
 * The terms are `RefundTerms`, which the FAQ's refund answer renders as well: this brand
 * publishes them twice and they have to say the same thing both times.
 *
 * Not in the task's original list for this brand. It was converted anyway because this
 * brand's terms of use link to it, and leaving it behind would have left exactly one page
 * on `layouts/about.html` — whose rail is DiscountMags' list, nine of whose fourteen
 * entries 404 on this domain. It is in the rail as well now, under Policies.
 *
 * "Refund Policy" is DiscountMags' name for this page, which is the name to use per the
 * brief. The legacy page disagreed with itself about its own: its `<h1>` said
 * "Cancellation Policy" while its `<title>` said "Refund Policy". The template still keeps
 * its own `<title>`.
 */
export default function RefundPolicy() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Refund Policy' }]} />

      <PageHeading eyebrow="Customer Information">Refund Policy</PageHeading>

      <ContentCard className="prose mt-6">
        <RefundTerms />
      </ContentCard>
    </>
  );
}

RefundPolicy.layoutName = 'Layouts.Institutional';
